import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SuperAdminDAshboardComponent } from './Layouts/super-admin-dashboard/super-admin-dashboard.component';
import { MaterialDesignModule } from './material-design/material-design.module';
import { StoreModule } from '@ngrx/store';
import { appReducers } from './store/reducers/app.reducers';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { CompanyEffects } from './store/effects/company.effects';
import { ServicesModule } from './Services/services.module';
import { UserEffects } from './store/effects/user.effects';
import { ToastrModule } from 'ngx-toastr';
import { AdminDashboardComponent } from './Layouts/admin-dashboard/admin-dashboard.component';
import { AgentEffects } from './store/effects/agent.effects';
import { ManufacturerEffects } from './store/effects/manufacturer.effects';
import { FileUploadModule } from 'ng2-file-upload';
import { MaterialEffects } from './store/effects/material.effects';
import { CompanyEmployeeEffects } from './store/effects/companyEmployee.effects';
import { FormulationEffects } from './store/effects/formulation.effects';
import { MLOEffects } from './store/effects/mlo.effects';
import { SOEffects } from './store/effects/so.effects';
import { CompanyEmployeeComponent } from './Layouts/company-employee/company-employee.component';
import { CustomerEffects } from './store/effects/customer.effects';
import { TasksEffects } from './store/effects/tasks.effects';
import { UOMEffects } from './store/effects/uom.effects';
import { UOTEffects } from './store/effects/uot.effects';
import { AllergenEffects } from './store/effects/allergen.effects';
import { WarehouseEffects } from './store/effects/warehouse.effects';
import { POEffects } from './store/effects/po.effects';
import { DocumentsEffects } from './store/effects/documents.effects';
import { HaccpEffects } from './store/effects/haccp.effects';
import { TraceabilityEffects } from './store/effects/traceability.effects';
import { GlobalDocumentsEffects } from './store/effects/globalDocuments.effects';
import {AddProductTypeComponent}from './PopUps/add-product-type/add-product-type.component';
import { AddDocumentTypeComponent } from './PopUps/add-document-type/add-document-type.component';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { AddHazardTypeComponent } from './PopUps/add-hazard-type/add-hazard-type.component';
import { AddDocumentNameComponent } from './PopUps/add-document-name/add-document-name.component';
import { FormulationEditStockInfoComponent } from './PopUps/formulation-edit-stock-info/formulation-edit-stock-info.component';
// import { FoodSafetySystemComponent } from './Layouts/admin-dashboard/food-safety-system/food-safety-system.component';
import {EditQuantityInfoComponent} from './PopUps/edit-quantity-info/edit-quantity-info.component';
// import { AllUsersComponent } from './Layouts/super-admin-dashboard/all-users/all-users.component';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

@NgModule({
  declarations: [
    AppComponent,
    SuperAdminDAshboardComponent,
    AdminDashboardComponent,
    CompanyEmployeeComponent,
    AddDocumentTypeComponent,
    AddHazardTypeComponent,
    AddDocumentNameComponent,
    FormulationEditStockInfoComponent,
    EditQuantityInfoComponent,
    AddProductTypeComponent,
    // AllUsersComponent,
    // FoodSafetySystemComponent,
  ],
  // entryComponents: [AddDocumentTypeComponent, AddHazardTypeComponent],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MaterialDesignModule,
    ServicesModule, FileUploadModule,
    StoreModule.forRoot(appReducers),
    StoreDevtoolsModule.instrument({
      name: 'AbleTrace Solutions',
    connectInZone: true}),
    EffectsModule.forRoot([
      CompanyEffects,
      UserEffects,
      AgentEffects,
      ManufacturerEffects,
      MaterialEffects,
      CompanyEmployeeEffects,
      FormulationEffects,
      MLOEffects,
      SOEffects,
      CustomerEffects,
      TasksEffects,
      UOMEffects,
      UOTEffects,
      AllergenEffects,
      WarehouseEffects,
      POEffects,
      DocumentsEffects,
      HaccpEffects,
      TraceabilityEffects,
      GlobalDocumentsEffects,
    ]),
    StoreRouterConnectingModule.forRoot({stateKey: 'router'}),
    ToastrModule.forRoot(),
    // AddPoModule,
  ],
  exports:[
    MatSnackBarModule,
  ],
 // providers: [ConnectionService],
 // providers: [{provide: LocationStrategy, useClass: HashLocationStrategy}],
 bootstrap: [AppComponent]
})
export class AppModule { }
